// @flow
import React, { useEffect, useState } from 'react'
import { httpGet } from 'lib/http'
import formatters from 'lib/formatters'
import { Table, Row, Cell } from 'components/Table'
import { Loader } from 'components/Notifications'
import LinkButton from 'components/LinkButton/LinkButton'
import { LockUnlockIcon } from '../Distributions/components/permissions'
import { sortByKey } from '../Distributions/components/Queue/sort'
import queueStyles from '../Distributions/components/Queue/styles'
import styles from './styles'

const buildHeaders = ({ sort, handleFilter }) => [
  { value: 'Beneficiary', sort, filter: 'beneficiaryName', handleFilter, className: queueStyles.tableHeader, id: 'beneficiaryName' },
  { value: 'Account #', sort, filter: 'accountNumber', handleFilter, className: queueStyles.tableHeader, id: 'accountNumber' },
  { value: 'Stage', sort, filter: 'station', handleFilter, className: queueStyles.tableHeader, id: 'station' },
  { value: 'Last Action', sort, filter: 'lastEventDescription', handleFilter, className: queueStyles.tableHeader, id: 'lastEventDescription' },
  { value: 'By', sort, filter: 'lastEventUser', handleFilter, className: queueStyles.tableHeader, id: 'lastEventUser' },
  { value: 'Last Updated', sort, filter: 'updatedAt', handleFilter, className: queueStyles.tableHeader, id: 'updatedAt' },
  {
    value: <LockUnlockIcon lockedForEdit={true} />,
    sort,
    filter: 'lockedForEdit',
    handleFilter,
    className: queueStyles.tableHeader,
    id: 'lockedForEdit',
  },
]

const Main = () => {
  const [accountQueue, setAccountQueue] = useState([])
  const [loading, setLoading] = useState(true)
  const [sort, setSort] = useState({ key: null, type: null, id: null })

  useEffect(() => {
    httpGet('/admin/action-queue').then((data) => {
      setAccountQueue(data.accounts)
      setLoading(false)
    })
  }, [])

  const handleFilter = (key, id) => {
    setSort((prev) => {
      let options = {
        key,
        id,
        type: prev.type === 'asc' || !prev.type ? 'desc' : 'asc',
      }
      if (prev.key != key) {
        options.type = 'asc'
      }
      return options
    })
  }

  const sortedQueue = sort.key ? sortByKey(accountQueue, sort.key, sort.type) : accountQueue
  const queueSize = sortedQueue.length
  const title = 'Pooled Accounts Queue' + (queueSize > 0 ? ` (${queueSize})` : '')

  const renderRow = (item) => (
    <Row key={`action-queue-item-${item.id}`} link={`/tickets/${item.id}`}>
      <Cell value={item.beneficiaryName} />
      <Cell value={item.accountNumber} account="gpt" />
      <Cell value={formatters.legibleStation(item.station)} />
      <Cell value={item.lastEventDescription} />
      <Cell
        value={
          <span className={styles.truncatedCell} title={item.lastEventUser}>
            {item.lastEventUser}
          </span>
        }
      />
      <Cell value={formatters.fileTimestamp(item.updatedAt)} />
      <Cell value={<LockUnlockIcon lockedForEdit={item.lockedForEdit} />} className={queueStyles.cellNoPadding} />
    </Row>
  )

  return (
    <section className={styles.contentContainer}>
      <div className={styles.header}>
        <h3 className={`pageTitle ${styles.title}`}>{title}</h3>
        <LinkButton className={styles.newAccountButton} to="/accounts/create">
          + New Pooled Account
        </LinkButton>
      </div>
      <div className={styles.fullWidth}>
        <Table headers={buildHeaders({ sort, handleFilter })} tableSize="infinite">
          {sortedQueue.map(renderRow)}
        </Table>
      </div>
      <Loader non_redux_loading={loading} />
    </section>
  )
}

export default Main
